const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetherlands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "19px",
    viewBox: "0 0 30 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,93.333333%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 0 6.578125 L 30 6.578125 L 30 12.421875 L 0 12.421875 Z M 0 6.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(68.235294%,12.156863%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 26.667969 0 L 3.332031 0 C 1.492188 0 0 1.308594 0 2.921875 L 0 6.578125 L 30 6.578125 L 30 2.921875 C 30 1.308594 28.507812 0 26.667969 0 Z M 26.667969 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.54902%,27.843137%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 3.332031 19 L 26.667969 19 C 28.507812 19 30 17.691406 30 16.078125 L 30 12.421875 L 0 12.421875 L 0 16.078125 C 0 17.691406 1.492188 19 3.332031 19 Z M 3.332031 19 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherlands);
export default __webpack_public_path__ + "static/media/netherlands.614234f78476f317cb3dbda9adbbdde7.svg";
export { ForwardRef as ReactComponent };